import React, { Component } from "react";
import GalleryContainer from "../../containers/gallery/index";
import BlogContainer from "../../containers/blogs/Blog";
import { useParams } from "react-router-dom";

const GalleryPage = () => {
  let { id } = useParams();

  return id ? <BlogContainer id={id} /> : <GalleryContainer />;
};

export default GalleryPage;